import CONFIGS from "build/Config";
import Button from "components/button"
import { useContext, useMemo, useState } from "react";
import { isInAppBrowser } from "utilities/detectDeviceAgent";
import { AxiosError } from "axios";
import { LoaderContext } from "contexts/loader-context";
import utmServices from "services/utm-services";
import { IBodyLoginExternal } from "../auth";
import GoogleSDK from "./google-sdk";
import FacebookSDK from "./facebook-sdk";
import AllowSocial from "./allow-social";

interface IProps {
  setStepper: React.Dispatch<React.SetStateAction<'start' | 'form'>>
  setError: (error: string | number) => void
  handleLoginExternal: (body: IBodyLoginExternal) => Promise<void>
}

export default function ViewStart({ setStepper, handleLoginExternal, setError }: IProps) {
  const typedThemeButtons: string[] = THEME === 'dosequis' ? ['google', 'facebook'] : CONFIGS?.buttonsStart
  const { setLoad } = useContext(LoaderContext)
  const [allowCookies, setAllowCookies] = useState<{ callback: any; isAllow: boolean }>()

  const handleSocial = async ({ bodyLogin }: { bodyLogin: IBodyLoginExternal }) => {
    setLoad(true)
    try {
      const utm = utmServices.utmRead()

      return setAllowCookies({
        callback: async ({ termsOfUse, subscribe, birthday, genreId, phone }: { termsOfUse: boolean; subscribe: boolean; birthday?: string, genreId: number, phone: string }) =>
          await handleLoginExternal({ ...bodyLogin, termsOfUse, subscribe, isLogin: false, birthday, genreId, phone, utm }),
        isAllow: true
      })
    } catch (error) {
      const code = (error as AxiosError).response?.data.code || 99999
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  const listSocial = useMemo(() => {
    return [
      {
        type: 'google',
        component: <GoogleSDK handleSubmit={handleSocial} setError={setError} />,
      },
      {
        type: 'facebook',
        component: <FacebookSDK handleSubmit={handleSocial} setError={setError} />
      },
    ].filter(({ type }) => {
      const isDisplayInTheme = typedThemeButtons.includes(type)

      return isDisplayInTheme
    }).sort((a, b) => typedThemeButtons.indexOf(a.type) - typedThemeButtons.indexOf(b.type))
  }, [])

  if (allowCookies?.isAllow) {
    return <AllowSocial onSubmit={allowCookies?.callback} />
  }

  return (
    <article className="w-full my-8 flex flex-col items-center flex-1 gap-4">
      <div className="w-full flex-1">
        <img src={`${AZURE_BASE_URL}/wifi/start.webp`} alt="WIFI START" />
      </div>
      <div className="w-full px-4 space-y-2 flex flex-col items-center">
        {listSocial?.length > 0 && (
          listSocial.map((social, index) => {
            const inBrowserApp = isInAppBrowser()

            if (inBrowserApp && ['google', 'twitch'].includes(social?.type)) {
              return null;
            }

            return (
              <span className="w-full" key={index}>
                {social.component}
              </span>
            )
          })
        )}
        <Button onClick={() => setStepper('form')}>ENTRAR CON TELÉFONO</Button>
      </div>
    </article>
  )
} 